import { FormError } from '@/constant';

import * as Yup from 'yup';

import { TValue } from './modal-add.type';

export const initialValues: TValue = {
	title: '',
	url: '',
};

export const validationSchema = Yup.object().shape({
	title: Yup.string().trim().required(FormError.REQUIRED),
	url: Yup.string().trim().required(FormError.REQUIRED),
});
